import type {ICategory} from '../schema';

export const canSearchCategory = (category?: ICategory) => !!category;
